'use strict';

var cov_12uftieh0o = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/HardwareType.js',
      hash = '92e67c0f73afe7fd37d9d80ae20ff76b5f147ebf',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/SecutixObjects/lib/HardwareType.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 21
        },
        end: {
          line: 6,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareType = (cov_12uftieh0o.s[0]++, _propTypes2.default.shape({
  driverName: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['TICKET_PRINTER', 'TPE', 'RECEIPT_PRINTER', 'UNKNOWN'])
}));

exports.default = HardwareType;